var map = {
	"./logo-pad-white.svg": 7251,
	"./pad-sotrad.png": 5217,
	"./pump-and-drink-color-r.png": 3318,
	"./pump-and-drink-color.png": 7819,
	"./sdg.png": 5328,
	"./sotrad-water-small.png": 8053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9683;